export default "__VITE_PUBLIC_ASSET__1f175e2e__"